import { atom, useAtomValue, useSetAtom } from 'jotai'
import { MentionableItem } from '../../../../types'

export const showMentionsAtom = atom(false)
export const mentionSearchAtom = atom('')
export const selectedMentionIndexAtom = atom(0)
export const cursorPositionAtom = atom(0)
export const messageMentionsAtom = atom<Array<MentionableItem>>([])
/** True when the menu was opened via `/` (skills-only mode); false for `@` mode */
export const slashModeAtom = atom(false)
/**
 * True when the menu was opened from the @ button, with no query typed into the composer, so it
 * brings its own search field; false while the composer text is the query.
 */
export const mentionsSearchFieldAtom = atom(false)

/**
 * The one way to open the menu, and the mirror of `closeMentionsAtom`: an open
 * is a fresh session, never a bare `showMentions = true` layered over whatever
 * the last one left behind (a stale query filtering the list down, a highlight
 * index off the end, `/`'s skills-only mode answering an `@`).
 */
export const openMentionsAtom = atom(null, (_get, set, options?: { slashMode?: boolean; searchField?: boolean }) => {
  set(showMentionsAtom, true)
  set(slashModeAtom, options?.slashMode ?? false)
  set(mentionsSearchFieldAtom, options?.searchField ?? false)
  set(mentionSearchAtom, '')
  set(selectedMentionIndexAtom, 0)
})

/**
 * The one way to close the menu. Every dismissal — pick, escape, click-outside,
 * a query that stopped matching, the composer unmounting out from under it —
 * leaves the same state behind, so callers can't drift into closing it half-way.
 */
export const closeMentionsAtom = atom(null, (_get, set) => {
  set(showMentionsAtom, false)
  set(slashModeAtom, false)
  set(mentionsSearchFieldAtom, false)
  set(mentionSearchAtom, '')
  set(selectedMentionIndexAtom, 0)
})

export const useCursorPosition = () => useAtomValue(cursorPositionAtom)

export const useIsShowingMentions = () => useAtomValue(showMentionsAtom)
export const useOpenMentions = () => useSetAtom(openMentionsAtom)
export const useCloseMentions = () => useSetAtom(closeMentionsAtom)

export const useMessageMentions = () => useAtomValue(messageMentionsAtom)
export const useSetMessageMentions = () => useSetAtom(messageMentionsAtom)
